import { render } from "./PartnerTccRemainder.vue?vue&type=template&id=3b62a7f6&scoped=true"
import script from "./PartnerTccRemainder.vue?vue&type=script&lang=js"
export * from "./PartnerTccRemainder.vue?vue&type=script&lang=js"

import "./PartnerTccRemainder.vue?vue&type=style&index=0&id=3b62a7f6&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b62a7f6"]])

export default __exports__